module.exports = __webpack_public_path__ + "static/media/СЛ ночь.5597cc5e.jpg";